/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CheckAction } from '@pages/Check/Enums';
// eslint-disable-next-line import/no-cycle
import { KioskMode } from '@pages/Kiosk/service';

import { RootState } from './store';

export interface State {
  name: string;
  action?: CheckAction;
  enabled: boolean;
  mode?: KioskMode;
}

export const initialState: State = {
  name: '',
  action: undefined,
  enabled: false,
  mode: undefined,
};

const kioskSlice = createSlice({
  name: 'kiosk',
  initialState,
  reducers: {
    setKioskName: (state: State, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
    setKioskEnabled: (state: State, action: PayloadAction<boolean>) => {
      state.enabled = action.payload;
      if (!action.payload) {
        state.name = initialState.name;
        state.action = initialState.action;
        state.enabled = initialState.enabled;
      }
    },
    setKioskMode: (state: State, action: PayloadAction<KioskMode>) => {
      state.mode = action.payload;
    },
  },
});

export default kioskSlice;

export const getKioskName = (state: RootState) => state[kioskSlice.name].name;
export const getKioskEnabled = (state: RootState) => state[kioskSlice.name].enabled;
export const getKioskMode = (state: RootState) => state[kioskSlice.name].mode;

export const {
  actions: { setKioskName, setKioskEnabled, setKioskMode },
  reducer: kioskReducer,
} = kioskSlice;
